import * as React from 'react';

export type SocialPreviewSkin = 'social' | 'twitter';

export type SocialPreviewSize = 'large' | 'small';

export interface SocialPreviewProps {
  dataHook?: string;
  /** A social post link title */
  title?: string;
  /** A social post link description */
  description?: string;
  /** A url representation of the social post link */
  previewUrl?: string;
  /** A slot to render a media item, most common will be the ImageViewer component */
  media?: React.ReactNode;
  /** Changes the style of the preview
   * @default 'social'
   */
  skin?: SocialPreviewSkin;
  /** Specifies the size of the preview. Size small works only in combination with twitter skin
   * @default 'large'
   */
  size?: SocialPreviewSize;
}

export class SocialPreview extends React.Component<SocialPreviewProps> {}
